export const renderBlinkingDots = () => {
  let rafId = -1;
  // 获取canvas元素和上下文
  const canvas = document.getElementById("sharpenCanvas") as HTMLCanvasElement || undefined;
  const container = document.querySelector("#sharpenCanvasContainer") as HTMLDivElement || undefined;

  console.log(canvas, container)
  if (!canvas || !container) {
    return () => null
  }
  container.style.opacity = '1'
  // 设置canvas尺寸与容器一致
  canvas.width = container.offsetWidth;
  canvas.height = container.offsetHeight;

  const ctx = canvas.getContext("2d", { alpha: true });

  // 确保Canvas背景是透明的
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // 定义小方块相关参数
  const baseSize = 2; // 基础大小
  const dotSpacing = 18; // 点之间的间距
  const dots = [];

  // 计算行列数以铺满画布
  const rows = Math.floor(canvas.height / dotSpacing);
  const cols = Math.floor(canvas.width / dotSpacing);

  // 计算偏移量使点阵居中
  const offsetX = (canvas.width - (cols - 1) * dotSpacing) / 2;
  const offsetY = (canvas.height - (rows - 1) * dotSpacing) / 2;

  // 创建整齐排列的点，铺满画布
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const x = offsetX + col * dotSpacing;
      const y = offsetY + row * dotSpacing;

      // 为每个点设置不同的初始相位，使呼吸效果错开
      const phase = Math.random() * Math.PI * 2;

      // 设置呼吸周期（毫秒）- 每个点周期略有不同
      const breathPeriod = Math.random() * 400 + 600; // 1500-2500ms之间

      // 基础大小和透明度
      const minOpacity = 0.2;
      const maxOpacity = 0.8;
      const minSize = baseSize * 0.5;
      const maxSize = baseSize * 1.2;

      dots.push({
        x,
        y,
        phase,
        breathPeriod,
        minOpacity,
        maxOpacity,
        minSize,
        maxSize,
        startTime: Date.now(), // 记录开始时间用于计算当前相位
      });
    }
  }

  function draw() {
    // 清除Canvas但保持透明
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const currentTime = Date.now();

    // 绘制呼吸效果的方块
    dots.forEach((dot) => {
      // 计算当前相位 (当前时间 + 初始相位偏移)
      const elapsedTime = currentTime - dot.startTime;
      const currentPhase =
        (elapsedTime / dot.breathPeriod) * Math.PI * 2 + dot.phase;

      // 使用正弦函数计算当前透明度和大小 (值在0-1之间)
      const sineValue = (Math.sin(currentPhase) + 1) / 2; // 转换为0-1范围

      // 计算当前透明度和大小
      const opacity =
        dot.minOpacity + sineValue * (dot.maxOpacity - dot.minOpacity);
      const size = dot.minSize + sineValue * (dot.maxSize - dot.minSize);

      // 设置填充样式
      ctx.fillStyle = `rgba(255, 255, 255, ${opacity})`;

      // 绘制方形
      const halfSize = size / 2;
      ctx.fillRect(dot.x - halfSize, dot.y - halfSize, size, size);
    });

    // 请求下一帧动画
    rafId = requestAnimationFrame(draw);
  }

  rafId = requestAnimationFrame(draw)

  return () => {
    container.style.opacity = '0'
    cancelAnimationFrame(rafId)
  }
}
